<template>
  <div>
    <v-card class="mb-4">
      <v-card-title>
        Address
      </v-card-title>
      <v-card-text>
        <v-text-field v-model="form.billing_address"
                      label="Address Line 1"
                      outlined>
        </v-text-field>

        <v-text-field v-model="form.billing_address_line_2"
                      label="Address Line 2"
                      outlined
                      placeholder="Optional">
        </v-text-field>

        <v-row>
          <v-col cols="12"
                 sm="4">
            <v-text-field v-model="form.billing_city"
                          label="City"
                          outlined>
            </v-text-field>
          </v-col>

          <v-col cols="12"
                 sm="4">
            <v-text-field v-model="form.billing_state"
                          label="State"
                          outlined
                          hint="This should be the 2-character abbreviation">
            </v-text-field>
          </v-col>

          <v-col cols="12"
                 sm="4">
            <v-text-field v-model="form.billing_zip"
                          label="ZIP Code"
                          outlined>
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import formValidation from '../../../plugins/formValidation';

export default {
  mixins: [formValidation],
  props: {
    form: {
      type: Object,
      required: true,
    },
    user: {
      type: Object,
      required: false,
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'activeUsers',
      'countries',
      'currentUser',
      'groups',
      'isAdmin',
      'isMember',
      'locales',
      'team',
      'teamRoles',
      'timezones',
    ]),
    isCurrentUser() {
      return this.user
        && this.currentUser.id === this.user.id;
    }
  },
}
</script>
